import { render, staticRenderFns } from "./ReceptionTable.vue?vue&type=template&id=c1850b44&"
import script from "./ReceptionTable.vue?vue&type=script&lang=js&"
export * from "./ReceptionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports